module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible()),
      expression: "visible()"
    }],
    attrs: {
      "id": "cookieConsentWrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "small secondary button mrb0",
    on: {
      "click": function($event) {
        _vm.set()
      }
    }
  }, [_vm._v("CONTINUE")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                We use cookies to help provide you with the best possible online experience."), _c('br'), _vm._v("\n                By using this site, you agree that we may store and access cookies on your device. You can find out more and set your own preferences "), _c('a', {
    attrs: {
      "href": "/cookies"
    }
  }, [_vm._v("here")]), _vm._v(".\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4256869a!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/Cookie/CookieConsent.vue
// module id = 412
// module chunks = 0